"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridContentMixin = void 0;
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @class GridContentMixin */
/** @method */
var GridContentMixin = function GridContentMixin(props) {
  var backgroundToken = 'GridContent.backgroundColor';
  if (typeof props.backgroundColor !== 'undefined') {
    backgroundToken = "colors." + props.backgroundColor;
  }
  return (0, _styledToken.default)({
    backgroundColor: backgroundToken,
    borderRadius: 'GridContent.borderRadius'
  }, function (tokens) {
    var styles = ["border-radius: " + tokens.borderRadius + "px;"];
    if (tokens.backgroundColor) {
      styles.push("background-color: " + tokens.backgroundColor);
    }
    return styles;
  })(props);
};
exports.GridContentMixin = GridContentMixin;